import React, { useState, useRef, useEffect, use } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import Select from './Select';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedBusiness, setBusinessList } from 'redux/reducers/businessSlice';
import { logoutUser } from 'redux/reducers/authSlice';
import { getBusinessesWithRoles } from 'services/businessService';


const HeaderBar = ({onToggleSidebar, isSidebarCollapsed = false }) => {
  const [navigationItems, setNavigationItems] = useState([]);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const userMenuRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const userDetails = useSelector((state) => state?.auth?.user);
  const businessStore = useSelector((state) => state?.business);
  const dispatch = useDispatch();

  // const navigationItems = [
  //   { label: 'Dashboard', path: '/admin-dashboard', icon: 'LayoutDashboard' },
  //   { label: 'Booking', path: '/booking-management', icon: 'ChartLine' },
  //   { label: 'Staff', path: '/staff-management', icon: 'Users' },
  //   { label: 'Category', path: '/category-management', icon: 'Settings' },
  //   { label: 'Services', path: '/service-management', icon: 'Wrench' },
  //   { label: 'Settings', path: '/business-profile-settings', icon: 'Settings' },
  // ];

  const loadBusinesses = async () => {
    if(businessStore.businessList && businessStore.businessList.length > 0){
      if(businessStore.selectedBusiness == null){
        dispatch(setSelectedBusiness(businessStore.businessList[0]));
      }
    }
    else{
      //Make API call to load businesses
      const response = await getBusinessesWithRoles();
      if(response && response.data.length > 0){
        //setBusiness(response.data);
        dispatch(setBusinessList(response.data));
        dispatch(setSelectedBusiness(response.data[0]));
      }
    }
  }

  const setNavigation = () => {
    const navigationItems = [
      {
        label: 'Dashboard',
        path: '/admin-dashboard',
        icon: 'LayoutDashboard',
        description: 'Overview and analytics'
      }
    ];

    const selectedBusiness = businessStore?.selectedBusiness;
    if(selectedBusiness == null) {
      setNavigationItems(navigationItems);
      return;
    }

    if(selectedBusiness.admin || selectedBusiness.owner || selectedBusiness.scanning || selectedBusiness.releasing){
      navigationItems.push(
        {
          label: 'Booking Management',
          path: '/booking-management',
          icon: 'ChartLine',
          description: 'Manage bookings'
        }
      )
    }

    if(selectedBusiness.admin || selectedBusiness.owner){
      navigationItems.push(
        {
          label: 'Staff Management',
          path: '/staff-management',
          icon: 'Users',
          description: 'Manage team members'
        },
        {
          label: 'Category Management',
          path: '/category-management',
          icon: 'FolderCog',
          description: 'Configure business categories'
        },
        {
          label: 'Service Management',
          path: '/service-management',
          icon: 'Wrench',
          description: 'Configure services and pricing'
        },
        {
          label: 'Business Settings',
          path: '/business-profile-settings',
          icon: 'Settings',
          description: 'Business profile and configuration'
        }
      )
    }

    if(selectedBusiness.admin || selectedBusiness.owner || selectedBusiness.reporting){
      navigationItems.push(
        {
          label: 'Reporting',
          path: '/reporting',
          icon: 'Landmark',
          description: 'Generate and view business reports'
        }
      )
    }


    setNavigationItems(navigationItems);
      
  }

  const handleBusinessChange = (businessId) => {
    const selectedBusiness = businessStore.businessList.find(business => business.businessId === businessId);
    if(selectedBusiness){
      dispatch(setSelectedBusiness(selectedBusiness));
    }
  }

  

  const handleLogout = () => {
    dispatch(logoutUser());
    dispatch(setSelectedBusiness(null));
    dispatch(setBusinessList([]));
    navigate('/login');
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const isActivePath = (path) => location?.pathname === path;

  useEffect(() => {
    loadBusinesses();
    const handleClickOutside = (event) => {
      if (userMenuRef?.current && !userMenuRef?.current?.contains(event?.target)) {
        setIsUserMenuOpen(false);
      }
      if (mobileMenuRef?.current && !mobileMenuRef?.current?.contains(event?.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
      setNavigation();
    }, [businessStore?.selectedBusiness]);

  return (
    <header className="fixed top-0 left-0 right-0 z-1000 bg-card border-b border-border elevation-1">
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        {/* Left Section - Logo and Mobile Menu Toggle */}
        <div className="flex items-center space-x-4">
          {/* Mobile Menu Toggle */}
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden"
            onClick={() => {setIsMobileMenuOpen(!isMobileMenuOpen);}}
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={20} />
          </Button>

          {/* Desktop Sidebar Toggle */}
          <Button
            variant="ghost"
            size="icon"
            className="hidden lg:flex"
            onClick={onToggleSidebar}
          >
            <Icon name={isSidebarCollapsed ? 'PanelLeftOpen' : 'PanelLeftClose'} size={20} />
          </Button>

          {/* Logo */}
          <div className="flex items-center space-x-2">
            {/* <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
              <Icon name="Car" size={20} color="white" />
            </div> */}
            <span className="text-lg font-semibold text-foreground hidden sm:block">
              Just Booked
            </span>
          </div>
        </div>

        {/* Center Section - Desktop Navigation */}
        {/* <nav className="hidden lg:flex items-center space-x-1">
          {navigationItems?.map((item) => (
            <Button
              key={item?.path}
              variant={isActivePath(item?.path) ? 'default' : 'ghost'}
              size="sm"
              onClick={() => handleNavigation(item?.path)}
              iconName={item?.icon}
              iconPosition="left"
              iconSize={16}
              className="transition-smooth"
            >
              {item?.label}
            </Button>
          ))}
        </nav> */}

        {/* Right Section - User Menu */}
        <div className="flex items-center space-x-4">
          {/* User Profile Dropdown */}
          <div className="relative" ref={userMenuRef}>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
              className="flex items-center space-x-2 transition-smooth"
            >
              <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                <Icon name="User" size={16} color="white" />
              </div>
              <span className="hidden md:block text-sm font-medium text-foreground">
                {userDetails?.displayName || '...'}
              </span>
              <Icon 
                name="ChevronDown" 
                size={16} 
                className={`transition-transform duration-200 ${isUserMenuOpen ? 'rotate-180' : ''}`}
              />
            </Button>

            {/* User Dropdown Menu */}
            {isUserMenuOpen && (
              <div className="absolute right-0 top-full mt-2 w-56 bg-popover border border-border rounded-lg elevation-2 animate-fade-in">
                <div className="p-3 border-b border-border">
                  <p className="text-sm font-medium text-foreground">
                    {userDetails?.displayName || '...'}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {userDetails?.email || 'user@carwash.com'}
                  </p>
                </div>
                <div className="p-3 border-b border-border">
                  <p className="text-sm font-medium text-foreground">
                    Business Profile
                  </p>
                  <select
                    className="w-full text-sm px-1 py-1 border border-border rounded-lg bg-input text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                    value={'Test'}
                    onChange={(e) => handleBusinessChange(e?.target?.value)}
                  >
                    {businessStore.businessList?.map(business => (
                      <option key={business.businessId} value={business.businessId}>{business.businessName}</option>
                    ))}
                  </select>
                </div>
                <div className="p-1">
                  {(businessStore.selectedBusiness?.admin || businessStore.selectedBusiness?.owner) &&
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => {
                        handleNavigation('/business-profile-settings');
                        setIsUserMenuOpen(false);
                      }}
                      iconName="Settings"
                      iconPosition="left"
                      iconSize={16}
                      className="w-full justify-start"
                    >
                      Business Settings
                    </Button>
                  }

                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => {
                      handleNavigation('/user-profile');
                      setIsUserMenuOpen(false);
                    }}
                    iconName="User"
                    iconPosition="left"
                    iconSize={16}
                    className="w-full justify-start"
                  >
                    User Profile
                  </Button>
                  
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={handleLogout}
                    iconName="LogOut"
                    iconPosition="left"
                    iconSize={16}
                    className="w-full justify-start text-destructive hover:text-destructive"
                  >
                    Sign Out
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Mobile Navigation Menu */}
      {isMobileMenuOpen && (
        <div 
          ref={mobileMenuRef}
          className="lg:hidden bg-card border-t border-border elevation-2 animate-slide-in"
        >
          <nav className="p-4 space-y-2">
            {navigationItems?.map((item) => (
              <Button
                key={item?.path}
                variant={isActivePath(item?.path) ? 'default' : 'ghost'}
                size="sm"
                onClick={() => handleNavigation(item?.path)}
                iconName={item?.icon}
                iconPosition="left"
                iconSize={16}
                className="w-full justify-start transition-smooth"
              >
                {item?.label}
              </Button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default HeaderBar;